import { useMutation } from "@apollo/client";
import type {
  UpdateConnectionInput,
  UpdateConnectionPayload,
  ConnectionPatch,
  Connection,
} from "@casey/db-types";
import { UPDATE_INTERVIEW_INVITE } from "../gql";

interface UpdateConnectionVariables {
  input: UpdateConnectionInput;
}

interface UpdateConnectionResponse {
  updateConnection: UpdateConnectionPayload;
}

export interface UseUpdateConnectionResult {
  updateConnection: (
    connectionCode: string,
    patch: ConnectionPatch,
  ) => Promise<Connection | null>;
  loading: boolean;
  error: Error | null;
}

export function useUpdateConnection(): UseUpdateConnectionResult {
  const [updateInviteMutation, { loading, error }] = useMutation<
    UpdateConnectionResponse,
    UpdateConnectionVariables
  >(UPDATE_INTERVIEW_INVITE, {
    errorPolicy: "all",
    onError: (error) => {
      console.error("Interview invite update error:", error);
    },
  });

  const updateConnection = async (
    connectionCode: string,
    patch: ConnectionPatch,
  ): Promise<Connection | null> => {
    try {
      const result = await updateInviteMutation({
        variables: {
          input: {
            connectionCode,
            patch,
          },
        },
      });

      const updatedInvite = result.data?.updateConnection?.connection;
      return updatedInvite || null;
    } catch (err) {
      console.error("Error updating interview invite:", err);
      throw err;
    }
  };

  return {
    updateConnection,
    loading,
    error: error || null,
  };
}
